import React, { memo, useMemo } from 'react';
import { createUseStyles, Text, useTheme } from 'hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Kpi');
const Kpi = /*#__PURE__*/memo(_ref => {
  let {
    data
  } = _ref;
  const classes = useStyles();
  const theme = useTheme();
  const renderBoxes = useMemo(() => {
    var _data$data;
    if (!(data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.length)) return null;
    return data.data.map((current, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classes.boxContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.boxValue
      }, /*#__PURE__*/React.createElement(Text, {
        type: "h3"
      }, current.value)), /*#__PURE__*/React.createElement("div", {
        className: classes.boxLabel
      }, /*#__PURE__*/React.createElement(Text, {
        type: "subtitle1",
        color: theme.colors.grey[500]
      }, current.label), current.labelBreakdown && /*#__PURE__*/React.createElement(Text, {
        type: "subtitle",
        color: theme.colors.grey[500]
      }, current.labelBreakdown)));
    });
  }, [data, classes, theme]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, renderBoxes);
});
export default Kpi;